export const getVNOrdersActionsParams = (route) => {
  return {
    route,
  }
}
